<script setup lang="ts">
import type { GetOrganizationTeamsQuery, GetOrganizationTeamsQueryVariables } from './TeamsSelector.generated'
import { GetOrganizationTeamsDocument } from './TeamsSelector.generated'

const { multiple = true } = defineProps<{
  multiple?: boolean
}>()

const selectedTeams = defineModel<string[] | string>({ required: true })
const { isFetching, search } = useRelayField<
  GetOrganizationTeamsQuery,
  GetOrganizationTeamsQueryVariables,
  SelectMenuOption[]
>(
  GetOrganizationTeamsDocument,
  computed(() => ({
    first: 50,
    term: '',
    existing: selectedTeams.value.length ? selectedTeams.value : undefined,
  })),
  ({ data }) =>
    getListOfNodes(data?.organization.teams).map((node) => ({
      label: node.name,
      value: node.id,
    })),
)
</script>

<template>
  <SelectMenu
    v-model="selectedTeams"
    :is-fetching="isFetching"
    :leading-icon="multiple ? 'light:magnifying-glass' : undefined"
    :placeholder="`Select ${multiple ? 'teams' : 'a team'}`"
    :searchable="search"
    option-attribute="label"
    value-attribute="value"
    selected-icon="light:check"
    :multiple="multiple"
    trailing
  />
</template>
